<div class="space-y-6">
    <div>
        <h3 class="text-lg font-semibold">{{ titulo }}</h3>
        <div [hidden]="!subtitle" class="text-md text-gray-600 dark:text-gray-400">{{ subtitle }}</div>
    </div>
    <!-- Lista de preguntas -->
    @for (item of items(); track item; let i = $index) {
        <!-- Sección -->
        @if (i === 0 || item.seccion !== items()[i - 1].seccion) {
            <div class="checklist-section text-gray-700 dark:text-gray-400">
                {{ item.seccion }}
            </div>
        }
        <!-- Fila de item -->
        <div class="checklist-row">
            <!-- Pregunta -->
            <div class="checklist-question text-[#0f172a] dark:text-gray-200">
                {{ item.pregunta }}
            </div>
            <!-- Botones con animación -->
            <div class="checklist-actions">
                <button type="button" [class.selected]="item.respuesta === 'OK'" [disabled]="readOnly" (click)="setRespuesta(i, 'OK')">Bien</button>
                <button type="button" [class.selected]="item.respuesta === 'REP'" [disabled]="readOnly" (click)="setRespuesta(i, 'REP')">Mal</button>
                @if (mostrarNA) {
                    <button type="button" [class.selected]="item.respuesta === 'NA'" [disabled]="readOnly" (click)="setRespuesta(i, 'NA')">N/A</button>
                }
            </div>
            <!-- Comentario -->
            <div class="checklist-comment">
                <input type="text" pInputText [placeholder]="commentPlaceholder" [(ngModel)]="item.comentario" [readonly]="readOnly" />
            </div>
        </div>
    }

    <!-- botón estático eliminado: la acción de 'Cargar' se realiza desde el modal padre -->
</div>
